module.exports = __webpack_public_path__ + "img/duplicate.c54f542d.svg";